module.exports = __webpack_public_path__ + "img/16_12.2ed2f295.png";